import { LogLevel } from "@azure/msal-browser";
export const msalConfig = {
    auth: {
 
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: "https://login.microsoftonline.com/" + process.env.REACT_APP_DIRECTORY_ID,
        redirectUri: process.env.REACT_APP_REDIRECT_URI
    }, 
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};
export const loginRequest = {
    scopes: ["https://graph.microsoft.com/.default"]

};

export const apiTokenRequest = {
    scopes: [`api://${process.env.REACT_APP_CLIENT_ID}/access_as_user`]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",//e.g. https://graph.microsoft.com/v1.0/me
    graphGetUsers: "https://graph.microsoft.com/v1.0/users" //e.g. https://graph.microsoft.com/v1.0/me
};

export const apiUrl = process.env.REACT_APP_API_URL;
// export const apiUrl = "http://localhost:8080";

// Log configuration values for debugging
console.log("=== Auth Config Initialized ===");
console.log("API URL:", apiUrl);
console.log("Redirect URI:", msalConfig.auth.redirectUri);
console.log("==============================");

//add http://localhost:8080 before denskat url for local backend testing
